import {
  GET_SECONDARY_HOME_BANNER_REQUEST,
  GET_SECONDARY_HOME_BANNER_SUCCESS,
  GET_SECONDARY_HOME_BANNER_FAILURE,
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SECONDARY_HOME_BANNER_REQUEST:
      return { ...state, isLoading: true, error: null };
  
    case GET_SECONDARY_HOME_BANNER_SUCCESS:
      return {
        data: action.payload,
        isLoading: false,
        error: null
      };
  
    case GET_SECONDARY_HOME_BANNER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};
  